module.exports = __webpack_public_path__ + "static/media/recruit-02.9fc87f75.png";